import { COMPANY_LEGAL_COPY } from '../../../../../v2/shared/company-legal-copy';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastService } from '../../../../../main/services';
import {TenderSuppliersService} from '../../../../services';
import {Supplier, Tender} from '../../../../models';
import {createSupplierForm} from '../../../../forms';
import {PHONE_MASK} from '../../../../../common/helpers';
import {FormValidationErrorsHelper} from "../../../../../common/helpers/forms/form-validation-errors-helper";
import { finalize } from 'rxjs/operators';

@Component({
    selector: 'jft-create-supplier-form-modal',
    templateUrl: './create-supplier-form-modal.component.html',
    styleUrls: ['./create-supplier-form-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CreateSupplierFormModalComponent implements OnInit {

    public form: UntypedFormGroup;
    /** D-549: "Company Legal Name", its tip and error. */
    public readonly legal = COMPANY_LEGAL_COPY;
    public contact: UntypedFormGroup;
    public phoneMask = PHONE_MASK;
    public availableTags: any[] = [];
    public selectedTags: any[] = [];
    public tags: any[] = [];
    public loading = false;

    constructor(
        private toast: ToastService,
        private tender: Tender,
        private supplierService: TenderSuppliersService,
        private activeModal: NgbActiveModal,
        private supplier: Supplier,
    ) {
    }

    public ngOnInit() {
        // @ts-ignore
        this.form = createSupplierForm(Supplier.create(this.supplier));
        this.contact = this.form.get('contact') as UntypedFormGroup;
        this.initAvailableTabs();
    }

    private initAvailableTabs() {
        this.availableTags.forEach((c, i) => {
            this.tags.push({id: c.id, name: c.name});
        });
    }

    public getFormGroupErrorClasses(control: AbstractControl): {} {
        return {'is-invalid': control.invalid && control.touched};
    }

    public showErrorBlock(control: AbstractControl): boolean {
        return control.errors && (control.dirty || control.touched);
    }

    public close() {
        this.activeModal.dismiss();
    }

    public submitSupplier() {
        if (!this.form.valid) {
            return;
        }

        this.form.disable();

        this.supplierService.createSupplier(this.tender, this.form.value)
            .pipe(finalize(() => this.form.enable()))
            .subscribe(
                data => {
                    this.activeModal.close({success: true, supplier: data});
                    this.toast.success(`The new supplier "${data.name}" has been successfully created in the system`);
                },
                err => this.toast.error(err)
            );
    }

    public getFirstFormGroupErrorLabel(form: UntypedFormGroup, contact: UntypedFormGroup) {
        if (contact.controls.email.errors && contact.controls.email.errors.required) {
            return 'Email field is required';
        }

        if (contact.controls.email.errors && contact.controls.email.errors.email) {
            return 'Email valid format is required';
        }

        let formValidationErrors = new FormValidationErrorsHelper();
        let formErrorLabel = formValidationErrors.getFirstErrorFormLabel(form);
        let contactGroupErrorLabel = formValidationErrors.getFirstErrorFormLabel(contact);

        if (formErrorLabel) {
            return formErrorLabel;
        } else if (contactGroupErrorLabel) {
            return contactGroupErrorLabel;
        }

        return '';
    }

    public tagChange(tags){
        this.form.get('contact.tags').patchValue(tags, {emitEvent: false});
    }

    public addTagPromise(name) {
        return {id: 0, name: name};
    }

}
